/*---------------------------------------------
Template name: .
Version: 1.0.0

[Table of Content]
----------------------
01: Preloader
02: Mixit UP
03: Lity
04: Swiper Slider
05: Back to Top
06: back to top button animate
----------------------------------------------*/

(function ($) {
	"use strict";

	/* ====== SHOW & HIDE MENU ====== */
	$(".menu-toggle-btn").click(function () {
		$(".main-menu").addClass("show-menu");
	});
	$(".menu-close-icon").click(function () {
		$(".main-menu").removeClass("show-menu");
	});

	/* ===== Logo Bar Slider ===== */
	$('.logo-bar-slider').slick({
		slidesToShow: 4,
		infinite: true,
		speed: 1500,
		autoplay: true,
		autoplaySpeed: 2000,
		arrows: false,
		dots: false,
      
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 500,
				settings: {
					slidesToShow: 3
				}
			}
		]
	});

	/* ===== Coach Slider ===== */
	$('.coach-slider').slick({
		centerMode: true,
		slidesToShow: 3,
		infinite: true,
		speed: 600,
		autoplay: false,
		arrows: false,
		dots: false,
      
		responsive: [{
				breakpoint: 768,
				settings: {
					centerPadding: '120px',
					slidesToShow: 1,
					autoplay: false,
					infinite: false,
                  
				}
			},
			{
				breakpoint: 511,
				settings: {
					centerPadding: '120px',
					slidesToShow: 1,
					autoplay: false,
					infinite: false,
                  
				}
			},
			{
				breakpoint: 475,
				settings: {
					centerPadding: '110px',
					slidesToShow: 1,
					autoplay: false,
					infinite: false,
                    
				}
			},

			{
				breakpoint: 430,
				settings: {
					centerPadding: '90px',
					slidesToShow: 1,
					autoplay: false,
					infinite: false,
                 
				}
			},
			{
				breakpoint: 375,
				settings: {
					centerPadding: '80px',
					slidesToShow: 1,
					autoplay: false,
					infinite: false,
                    
				}
			},
			{
				breakpoint: 350,
				settings: {
					centerPadding: '60px',
					slidesToShow: 1,
					autoplay: false,
					infinite: false,
                  
				}
			},
		]
	});

	/* ===== Field Slider ===== */
	$('.field-slider').slick({
		slidesToShow: 1,
		    infinite: false,
		variableWidth: true,
		adaptiveHeight: true,
		speed: 1400,
		arrows: true,
		dots: false,
		focusOnSelect: true,
		responsive: [{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					centerPadding: '140px',
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1,
					centerPadding: '200px',
				}
			},
			{
				breakpoint: 750,
				settings: {
					slidesToShow: 1,
					centerPadding: '100px',
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					centerMode: false,
					centerPadding: '60px',
					variableWidth: false,
				}
			},
			{
				breakpoint: 400,
				settings: {
					slidesToShow: 1,
					centerMode: false,
					centerPadding: '30px',
					variableWidth: false,
				}
			},
		]
	});

	/* ===== Reviews Slider ===== */
	$('.reviews-slider').slick({
		centerMode: true,
		centerPadding: '140px',
		slidesToShow: 3,
		infinite: true,
		speed: 1500,
		autoplay: true,
		autoplaySpeed: 2000,
		arrows: false,
		dots: false,
		responsive: [{
				breakpoint: 1200,
				settings: {
					centerPadding: '140px',
					slidesToShow: 2,
				}
			},
			{
				breakpoint: 950,
				settings: {
					slidesToShow: 1
				}
			},
			{
				breakpoint: 650,
				settings: {
					centerPadding: '100px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 576,
				settings: {
					centerPadding: '80px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 500,
				settings: {
					centerPadding: '60px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 450,
				settings: {
					centerPadding: '40px',
					slidesToShow: 1
				}
			}
		]
	});

	/* ===== PARALLAX EFFECT ===== */
	  var rellax = new Rellax('.rellax', {
	    speed: -2,
	    center: true,
	    wrapper: null,
	    round: true,
	    vertical: true,
	    horizontal: true
	  });
    //initiate Aos
    AOS.init({
        offset: 100,
        duration: 900,
        easing: 'ease',
    });


    // nice number
    $('.quantity').niceNumber({
        buttonPosition: 'around'
    });

    // cart slider
    $('.cart_slider').slick({
		centerMode: true,
		centerPadding: '60px',
		slidesToShow: 3,
		arrows: false,
		dots: true,
		responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        arrows: false,
		        centerMode: true,
		        centerPadding: '40px',
		        slidesToShow: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: false,
		        centerMode: true,
		        centerPadding: '40px',
		        slidesToShow: 1
		      }
		    }
		]
	});


	// plan slider

	$('.plan_slider').slick({
		centerMode: true,
          infinite: true,
		centerPadding: '60px',
		slidesToShow: 2,
		arrows: false,
		dots: false,
		responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        arrows: false,
		        centerMode: true,
		        centerPadding: '40px',
		        slidesToShow: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: false,
		        centerMode: true,
		        centerPadding: '40px',
		        slidesToShow: 1
		      }
		    }
		]
	});

  
  	// vertical slider


	$('.vertical_slider').slick({
		centerMode: false,
          infinite: false,
		centerPadding: '60px',
		slidesToShow: 3,
		arrows: false,
		dots: false,
		responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        arrows: false,
		        centerMode: true,
		        centerPadding: '40px',
		        slidesToShow: 2
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: false,
		        centerMode: true,
		        centerPadding: '40px',
		        slidesToShow: 1
		      }
		    }
		]
	});

	// plan slider

	$('.pdp_slider05').slick({
		centerMode: false,
		centerPadding: '60px',
		autoSlidesToShow: true,
		arrows: false,
		dots: false,
          infinite: false,
		responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        arrows: false,
		        centerMode: false,
		        centerPadding: '40px',
		       autoSlidesToShow: true
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        arrows: false,
		        centerMode: false,
		        centerPadding: '40px',
		      autoSlidesToShow: true
		      }
		    }
		]
	});


	// nice select
  $('select:not(.notNiceSelect)').niceSelect();

})(jQuery);

$(".tooltips").click(function () {
    var $title = $(this).find(".tooltiptexts");
    if (!$title.length) {
        $(this).append('<span class="tooltiptexts">' + $(this).attr("title") + '</span>');
    } else {
        $title.remove();
    }
});



 function showDiv2() {
   $('.redifine_plans_wrapper').css('visibility', 'visible'); 
    $('.redifine_plans_wrapper').css('height', 'auto'); 
    
   
    }

$(window).on('load', function(){

setTimeout("showDiv2()", 1000); 

});







 



  const openEls = document.querySelectorAll("[data-open]");
const closeEls = document.querySelectorAll("[data-close]");
const isVisible = "is-visible";

for (const el of openEls) {
  el.addEventListener("click", function() {

    const modalId = this.dataset.open;
    document.getElementById(modalId).classList.add(isVisible);
  });
}

for (const el of closeEls) {
  el.addEventListener("click", function() {
    this.parentElement.parentElement.parentElement.classList.remove(isVisible);
  });
}

document.addEventListener("click", e => {
  if (e.target == document.querySelector(".modal.is-visible")) {
    document.querySelector(".modal.is-visible").classList.remove(isVisible);
  }
});

document.addEventListener("keyup", e => {
  // if we press the ESC
  if (e.key == "Escape" && document.querySelector(".modal.is-visible")) {
    document.querySelector(".modal.is-visible").classList.remove(isVisible);
  }
});


$('.news-slider').slick({
		slidesToShow: 3,
		dots: false,
		arrows: false,
		// infinite: true,
		responsive: [
		    {
				breakpoint: 576, // max 576px
				settings: {
					slidesToShow: 2,
				}
		    },
		    {
				breakpoint: 768, // max 992px
				settings: {
					slidesToShow: 3,
					// infinite: true,
				}
		    },
		]
	});
          	$('.community-banner-slider').slick({
		slidesToShow: 3,
		arrows: false,
		dots: false,
		responsive: [
		    {
				breakpoint: 767, // max 767px
				settings: {
					slidesToShow: 2
				}
		    },
		]
	});
	$('.sweat-with-us .slick-slider').slick({
		centerMode: true,
		slidesToShow: 3,
		arrows: false,
		dots: false,
		responsive: [
		    {
				breakpoint: 479, // max 479px
				settings: {
					slidesToShow: 2,
					centerPadding: '0px',
				}
		    },
		    {
				breakpoint: 575, // max 575px
				settings: {
					slidesToShow: 3,
					centerPadding: '20px',
				}
		    },
		]
	});
	$('.member-slider .slick-slider').slick({
		centerMode: true,
		centerPadding: '60px',
		slidesToShow: 1,
		dots: false,
		arrows: true,
		prevArrow: $('.slide-arrow.prev-arrow'),
    	nextArrow: $('.slide-arrow.next-arrow'),
		responsive: [
		    {
				breakpoint: 767, // max 767px
				settings: {
					slidesToShow: 1,
					centerPadding: '35px',
				}
		    },
		    {
				breakpoint: 992, // max 992px
				settings: {
					slidesToShow: 1,
					centerPadding: '20px',
				}
		    },
		    {
				breakpoint: 1200, // max 1200px
				settings: {
					slidesToShow: 1,
					centerPadding: '0px',
				}
		    },
		]
	});
	$('.more-from-blazepod .slick-slider').slick({
		slidesToShow: 4,
		arrows: false,
		dots: false,
		responsive: [
		    {
				breakpoint: 992, // max 992px
				settings: {
					slidesToShow: 3
				}
		    },
		    {
				breakpoint: 576, // max 576px
				settings: {
					slidesToShow: 2
				}
		    },
		]
	});




$('.swiper-container.header').slick({
		slidesToShow: 1,
  centerMode: true,
          infinite: true,
 fade:true,
      autoplay: true,
      autoplaySpeed: 5000,
		dots: false,
		arrows: false,
		
	
	});
                                        

$('.product_gallery').slick({
		slidesToShow: 1,
  centerMode: true,
fade:true,
          infinite: false,
		dots: false,
		arrows: true,
		
	
	});


function selectOnlyThis(id){
  var myCheckbox = document.getElementsByName("myCheckbox");
  Array.prototype.forEach.call(myCheckbox,function(el){
  	el.checked = false;
  });
  id.checked = true;
}



$(".pdp_btn a.new").on("click",  bundle_new);


function bundle_new() {
	var productId = $('.pdp_main_wrapper form [name="id"]').val();
	var id = $('[membership-price]:checked').attr('id');
	var bundleId = Math.random().toString(36).slice(2,7);
	var bundleIdQ = Math.random().toString(36).slice(2,7);
	var isBundle = false;
	var formData = { items: [] };

	if (id == '6-month-blazepod-pro-option-1') {
		console.log('Membership ID:', id);

		formData.items.push({
			id: 40387475341356,
			quantity: 1,
			selling_plan: 722141228,
			properties: {
				_bundleId: `#${bundleId}`,
				_bundleIdQ: `#${bundleIdQ}`,
				_sellingPlan: 722141228,
				_itemEditable: false,
				_itemRemovable: true
			}
		});
		isBundle = true;
	}

	if (id == 'withoutMembership-option-1') {
		isBundle = true;
		data = {
			"id": 40387475341356,
			"quantity": 0,
			"selling_plan": 722141228,
			"properties": {
				"_bundleId": `#${bundleId}`,
				"_bundleIdQ": `#${bundleIdQ}`,
				"_sellingPlan": 722141228,
				"_itemEditable": false,
				"_itemRemovable": true
			}
		}
		jQuery.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: data,
			dataType: 'json',
			success: function() {}
		});

		data = {
			"id": 40707782410285,
			"quantity": 0,
			"selling_plan": 733216813,
			"properties": {
				"_bundleId": `#${bundleId}`,
				"_bundleIdQ": `#${bundleIdQ}`,
				"_sellingPlan": 733216813,
				"_itemEditable": false,
				"_itemRemovable": true
			}
		}
		jQuery.ajax({
			type: 'POST',
			url: '/cart/change.js',
			data: data,
			dataType: 'json',
			success: function() {}
		});
	}

	// Add main product
	if (isBundle) {
		formData.items.push({
			id: Number(productId),
			quantity: 1,
			properties: {
				_bundleId: `#${bundleId}`
			}
		});
	} else {
		formData.items.push({
			id: Number(productId),
			quantity: 1
		});
	}

	fetch(window.Shopify.routes.root + 'cart/add.js', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(formData)
	})
	.then(response => response.json())
	.then(() => (window.top.location = '/cart'))
	.catch((error) => {
		console.error('Error:', error);
		window.top.location.reload();
	});
}

 
    $(function() {

   if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {

 $(".main-menu").on("click", ".dropdown a", function() {
    if( $(this).parents().hasClass("active")) {
      $(this).parents().find(".firstlevel").hide();
          $(this).parents().removeClass("active");
} else {
        $(this).parents().addClass("active");
        $(this).parents().find(".firstlevel").show();
}
  });


   }else{
   $(".main-menu").on("mouseenter", ".dropdown", function() {
   
if( $(this).hasClass("active")) {
  
      $(this).find(".firstlevel").hide();
          $(this).find(".firstlevel").parent().removeClass("active");
} else {
   
        $(this).find(".firstlevel").parent().addClass("active");
        $(this).find(".firstlevel").show();
}
        $(this).on("mouseleave", function() {
          $(this).find(".firstlevel").hide();
          $(this).find(".firstlevel").parent().removeClass("active");
        });
      });

   


      $(".main-menu").on("mouseenter", ".twolevel", function() {

        var ww = $(window).width();
        var $menuItem = $(this).find(".thirdlevel");
        var $firstLevel = $(".firstlevel");
        var mw = $menuItem.width() + $firstLevel.offset().left + $firstLevel.width();
        var marginLeft = 0 - ($menuItem.width() + $firstLevel.width());
        if (ww < mw) {
          $menuItem.css("margin-left", marginLeft);
        }
        $menuItem.css("display", "block");
        $(this).on("mouseleave", function() {
          $(this).find(".thirdlevel").css("display", "none");
        });
      });
     
     }
   
       });



        var galleryThumbs = new Swiper('.gallery-thumbs', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.gallery-top', {
      spaceBetween: 10,
      
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: galleryThumbs
      }
    });

